<template>
  <div>
    <div class="live-info"  @click="goToregistry" :class="{show:isShow,info_close:isClose}">
        <div class="li-item">
          <div class="logo">
            <img
              :src="dataVal.AvatarUrl?dataVal.AvatarUrl:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=188149577,2949073731&fm=26&gp=0.jpg?x-oss-process=style/oAvatar'"
              v-load="'oAvatarSmall'"
            />
          </div>
          <div class="content">
            <div class="title">{{dataVal.NickName||dataVal.Name||''}}</div>
            <div class="info">已完成线上展登记</div>
          </div>
          <div class="icon">
            <img src="@assets/img/live/arrow-right.png" />
          </div>
        </div>
    </div>
    <div class="live-info" @click="goToregistry" :class="{show:newIsShow,info_close:newClose}">
        <div class="li-item">
          <div class="logo">
            <img
              :src="dataVal.AvatarUrl?dataVal.AvatarUrl:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=188149577,2949073731&fm=26&gp=0.jpg?x-oss-process=style/oAvatar'"
              v-load="'oAvatarSmall'"
            />
          </div>
          <div class="content">
            <div class="title">{{dataVal.NickName||dataVal.Name||''}}</div>
            <div class="info">已完成线上展登记</div>
          </div>
          <div class="icon">
            <img src="@assets/img/live/arrow-right.png" />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
export default {
  name: "live-info",
  data() {
    return {
      isShow:false,
      isClose:false,
      newIsShow:false,
      newClose:false,
      dataVal:{},
      timer:null,
      newTimer:null,
      arr: [
        {
          type: 0,
          title: "四级花都",
          info: "上海玫瑰寇企业"
        },
        {
          type: 1,
          title: "四级花都",
          info: "上海玫瑰寇企业"
        }
      ]
    };
  },
  computed:{
    ...mapGetters({
      userInfo: "getUserInfo",
    })
  },
  created() {
    // this.init();
  },
  methods: {
    ...mapActions({ 
      LinkRegistry: "linkTo/LinkRegistry",
      LinkEditPerson:"linkTo/LinkEditPerson"
    }),
    init() {
      setInterval(() => {
        const num = Math.random();
        let single = null;
        if (num > 0.5) {
          single = this.arr[0];
        } else {
          single = this.arr[1];
        }
        this.arr.push(single);
      }, 2000);
    },
    showOpen(date){
      this.dataVal=date;
      this.$nextTick(()=>{
        if(this.timer){
          this.newIsShow=true;
          this.newTimer=setTimeout(()=>{
            this.newClose=true;
            setTimeout(()=>{
              this.newIsShow=false;
              setTimeout(()=>{
                this.newClose=false;
              },500)
              this.newTimer=null;
            },600)
          },3000)
        }else{
          this.isShow=true;
          this.isClose=false;
          this.timer=setTimeout(()=>{
            this.isClose=true;
            setTimeout(()=>{
              this.isShow=false;
              setTimeout(()=>{
                this.isClose=false;
              },500)
              this.timer=null
            },600)
          },3000)
        }
      })
    },
    //去注册
    goToregistry(){
      if(this.userInfo.userRole>0){
        this.LinkEditPerson();
      }else{
        this.LinkRegistry(0);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.live-info {
  position: absolute;
  z-index: 99;
  left: -100%;
  bottom: 5rem; 
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  transition: all 0.5s;
  opacity: 1;
  &.show{
    left: 0.3rem;
  }
  &.info_close{
    opacity: 0;
  }
  .li {
    &-item {
      width: 3rem;
      height: 0.64rem;
      background-color: rgba(#32a1ff, 0.6);
      border: 0.02rem solid #0072ff;
      display: flex;
      align-items: center;
      border-radius: 0.32rem;
      .logo {
        padding: 0.08rem;
        margin-right: 0.12rem;
        display: flex;
        align-items: center;
        img {
          width: 0.48rem;
          height: 0.48rem;
          border-radius: 50%;
        }
      }
      .content {
        color: #fff;
        width: calc(100% - 1.3rem);
        .title {
          font-size: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .info {
          font-size: 0.16rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            font-size: 0.16rem;
          }
        }
      }
      .icon {
        display: flex;
        align-items: center;
        text-align: right;
        img {
          width: 0.36rem;
          height: 0.36rem;
          display: inline-block;
        }
      }
    }
    &-item2 {
      width: 100%;
      margin-top: 0.25rem;
      width: 3rem;
      height: 0.64rem;
      background-color: rgba(#e35c5a, 0.8);
      border: 0.02rem solid #e35c5a;
      display: flex;
      align-items: center;
      border-radius: 0.32rem;
      position: relative;
      .logo {
        padding: 0.08rem;
        margin-right: 0.12rem;
        display: flex;
        align-items: center;
        img {
          width: 0.48rem;
          height: 0.48rem;
          border-radius: 50%;
        }
      }
      .content {
        color: #fff;
        width: calc(100% - 0.4rem);
        padding-left: 0.28rem;
        padding-top: 0.08rem;
        .title {
          font-size: 0.2rem;
          line-height: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .info {
          line-height: 0.22rem;
          font-size: 0.16rem;
          display: flex;
          align-items: center;
          span {
            line-height: 0.22rem;
            width: 1.2rem;
            font-size: 0.16rem;
            font-weight: bold;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .icon {
        display: flex;
        align-items: center;
        text-align: right;
        img {
          position: absolute;
          width: 0.49rem;
          height: 0.76rem;
          bottom: 0.12rem;
          right: 0.18rem;
        }
      }
      .num {
        position: absolute;
        left: calc(100% + 0.1rem);
        bottom: -0.2rem;
        color: #fff;
        font-size: 0.72rem;
        font-weight: bold; 
        span {
          font-size: 0.36rem;
        }
      }
    }
  }
}
</style>
